import { LocalUnauthorizedReason } from '../../reasons'

import type { PermissionPluginFn } from '@circlefin/permissions'
import type { Session } from 'next-auth'

/**
 * Handle Permissions Error.
 */
export function errorPlugin(status?: Session['status']): PermissionPluginFn {
  return {
    verify: ({ authenticated }) => {
      // When the user is authenticated, but an error occurred.
      if (authenticated && status === 'error') {
        return {
          isAuthorized: false,
          failureReason: LocalUnauthorizedReason.errorOccurred,
        }
      }
    },
  }
}
